import { LoadedDraft, Post } from "../shared/types/post";
export type { LoadedDraft } from "../shared/types/post";
import {
  getPostState,
  isDocumentPost,
  isVideoPost,
  standardizationPostData,
  standardizationUpcomingPosts,
} from "../utils/posts";

export async function normalizeDraft(draft: LoadedDraft): Promise<LoadedDraft> {
  draft.checked = false;
  const post = draft.schedule;
  post._id = draft._id;
  post.accountIds = draft.accountIds;
  post.isVideo = isVideoPost(post);
  post.isDocument = isDocumentPost(post);
  post.unreadMessageCount = "";
  post.preview_enabled =
    post.platforms &&
    post.platforms.every(function (plf) {
      return !plf.platformType || plf.platformType == "instagram";
    });

  draft.schedule = await standardizationPostData(post);

  return draft;
}

export async function normalizeAnyPost(
  post: Post | LoadedDraft
): Promise<Post | LoadedDraft> {
  const state = getPostState(post);
  switch (state) {
    case "DRAFT": {
      return await normalizeDraft(post as LoadedDraft);
    }
    case "ARCHIVED": {
      return standardizationPostData(post as Post);
    }

    case "SCHEDULED":
    case "QUEUED": {
      const scheduledPosts = await standardizationUpcomingPosts(
        [post as Post],
        []
      );
      return scheduledPosts[0];
    }
  }
  return post;
}
